import { forwardRef, useCallback, useState } from "react";
import { Button } from "@mui/material";
import FileSaver from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";

import http from "../../../services/httpService";

const DownloadButton = forwardRef(({ url, filename, download = null, ...props }, ref) => {
    const [downloading, setDownloading] = useState(false);
    if (!download) {
        download = async (onDownload) => {
            const { data } = await http.get(url, { responseType: "blob" });
            onDownload(data);
        }
    }
    const handleAction = useCallback(async () => {
        if (downloading) return false;
        setDownloading(true);
        try {
            await download((blob) => {
                FileSaver.saveAs(blob, filename);
                setDownloading(false);
            }, url);
        } catch (e) {
            setDownloading(false);
            throw e;
        }
    }, [downloading, download, filename, url]);

    return (
        <Button
            disabled={downloading}
            onClick={handleAction}
            ref={ref}
            variant="contained"
            color="neutral"
            disableElevation={true}
            startIcon={<DownloadIcon />}
            {...props}
        >
            Download
        </Button>
    );
});

export default DownloadButton;
